export default __webpack_public_path__ + "static/media/img_9.8a0f475b.jpg";